import Reflux from "reflux";

export default {
    renderSpeed: Reflux.createAction("renderSpeed") as RefluxAction<[string, string, number]>,
    apiDataLoad: Reflux.createAction("apiDataLoad") as RefluxAction<[string, string, string, number]>
};
